import React from 'react';
import * as S from './styled';

export const MainLogo = ({ isBig = false }: { isBig?: boolean }) => (
  <S.LogoWrapper $isBig={isBig}>
    <S.Logo />
  </S.LogoWrapper>
);
